export default __webpack_public_path__ + "static/media/hallsofeternalfrostunchained.b649ae7b.jpg";